/**
 * What a TERRITORY area sales manager may open (owner, 17 Sep 2026: "except
 * for manish and goswami other ASM will be shown their mitra stock only and
 * will be able to place orders and check the status of their orders thats
 * it").
 *
 * The rail already offers only these; this is the same rule applied to the
 * address bar, so a bookmarked /performance or a shared /ageing link lands on
 * home instead of on a page the rail no longer shows. The server narrows every
 * read to the territory regardless — this is about what is SHOWN, not what is
 * readable.
 */
const ALLOWED = [
  /^\/$/,
  /^\/login$/,
  /^\/stock(\/|$)/,
  /^\/orders(\/|$)/,
  /^\/sub-dealers(\/|$)/, // their mitras — the holders of the stock they see
  /^\/vehicles\/[^/]+$/, // one of their own vehicles, tapped from the list
  /^\/enquiries$/, // who asked in the field (owner, 1 Oct 2026: "add enquiry form in every asm")
  /^\/field$/, // the old field desk's address — now sends meetings to Enquiries, expenses to My expenses (14 Oct 2026)
  /^\/my-verification$/, // their own Aadhaar and details (owner, 6 Oct 2026)
  /^\/enrol-employee$/, // enrolling an employee for approval, where switched on for them (7 Oct 2026)
  /^\/tasks$/, // their tasks from the owner (12 Oct 2026)
  /^\/approvals$/, // their counters' orders to answer, and what they asked (17 Oct 2026)
  /^\/expenses$/, // their own expenses, and nothing else on the page (owner, 14 Oct 2026: "expense will have only expense")
  /^\/attendance$/, // their own attendance — mark in, mark out, ask for leave (13 Oct 2026)
  /^\/sales-performance$/, // their counters' sales, the server holding them to their own (owner, 13 Oct 2026)
  /^\/meetings$/, // their meetings, logged one after another with a selfie and the place (owner, 23 Oct 2026)
  /^\/showrooms$/, // their counters' showroom checks — location and the marketing board (owner, 23 Oct 2026)
];

export function territoryMayVisit(pathname: string): boolean {
  return ALLOWED.some((rule) => rule.test(pathname));
}
